"use client";

import React from 'react';
import { DownOutlined, SmileOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Dropdown, Space } from 'antd';
import { useState, useEffect } from 'react';

export type EventCardProps = {
  data: RuleDataType
};

export type RuleDataType = {
  description: string,
  itemTitle: string
}[]
export const Rule: React.FC<EventCardProps> = ({
  data,
  ...props
}) => {
  const [selectIdx, setSelectIdx] = useState(0)
  const items: MenuProps['items'] = data.map((item, index) => {
    return {
      key: index,
      label: <span onClick={() => setSelectIdx(index)}>{item.itemTitle}</span>
    }
  })

  return (<div className="m-10 rounded-20 py-17 px-20" style={{ backgroundColor: "rgba(72, 66, 101, 0.5)" }}>
    <div className="flex items-center justify-between mb-20">
      <span className="font-bold text-15 leading-18 text-bravve-200 ">Rules</span>
      <div className="flex items-center">
        {
          items.length && items.length !== 1 ?
            <Dropdown menu={{ items }}>
              <a onClick={(e) => e.preventDefault()}>
                <Space>
                  <span className='text-13 text-bravve-200'>{data[selectIdx].itemTitle}</span>
                  <DownOutlined style={{ color: "#fff" }} />
                </Space>
              </a>
            </Dropdown>
            :
            null
        }
      </div>
    </div>
    <div className="text-15 leading-24 text-bravve-200 mt-18">
      {data[selectIdx].description}
    </div>
  </div>)
}